import { Command } from 'commander';
import { VaultPolicyService } from '../../services/vault-policy.service.js';
import { formatVaultBodyForHuman, formatVaultItemForHuman, shouldRequireRevealReason, unlockVault } from './shared.js';

interface RevealOptions {
    reason?: string;
    passphrase?: string;
    recoveryKey?: string;
    raw?: boolean;
    json?: boolean;
}

export function createVaultRevealCommand(): Command {
    return new Command('reveal')
        .description('Reveal a vault item after policy checks')
        .argument('<id>', 'Vault item id')
        .option('--reason <reason>', 'Operational reason for reveal; required when item contains secrets')
        .option('--passphrase <value>', 'Vault passphrase')
        .option('--recovery-key <value>', 'Recovery key')
        .option('--raw', 'Output raw body without human formatting')
        .option('-j, --json', 'Output JSON')
        .action(async function (this: Command, id: string, options: RevealOptions) {
            const { store, vmk } = await unlockVault(options);
            const item = await store.readPlainItem(vmk, id);
            if (shouldRequireRevealReason(item, options.reason)) {
                throw new Error('Reveal reason required because this item is marked as containing secrets. Use --reason "<why>".');
            }
            const decision = new VaultPolicyService().evaluateReveal(item, options.reason);
            if (!decision.allowed) throw new Error(decision.message || 'Reveal denied.');
            const useJson = !!(options.json || this.optsWithGlobals().json);
            if (useJson) {
                console.log(JSON.stringify({ item, reason: options.reason }, null, 2));
                return;
            }
            if (options.raw) {
                console.log(typeof item.body === 'string' ? item.body : JSON.stringify(item.body, null, 2));
                return;
            }
            console.log(formatVaultItemForHuman(item, { includeBody: 'always', reason: options.reason }));
        });
}
